import React, { ReactNode } from 'react';
import '../AiBrunixPanel.css';

interface UserQueryProps {
  children: ReactNode;
}

export const UserQuery = ({ children }: UserQueryProps) => {
  return (
    <div className="ai-brunix-panel-query-container">
      <span className="ai-brunix-panel-query-label">User_Query</span>
      <div className="ai-brunix-panel-query-bubble">
        <div className="ai-brunix-panel-query-text">{children}</div>
      </div>
    </div>
  );
};
